export default __webpack_public_path__ + "static/media/checkmark.dc2d18df.svg";